module.exports = __webpack_public_path__ + "static/media/upp_flo_sla_anc.6b9e8385.png";